<div class="loading-spinner" *ngIf="isLoading; else loaded">
  <div class="cc-icon cc-icon-spinner"></div>
</div>
<ng-template #loaded>
  <form #form="ngForm" novalidate (submit)="form.valid && onSubmit()" class="sm-flex sm-flex-col sm-gap-4">
    <h1 class="sm-text-xl sm-font-medium" i18n>Security</h1>

    <!-- Single Sign-On (SSO) -->
    <div class="row" data-test="single-sign-on-input-toggle">
      <label i18n class="default-label col-form-label col-sm-4">Single sign-on (SSO)</label>
      <div class="col-sm-8">
        <cc-input-toggle
          class="sm-flex sm-items-center sm-gap-x-2"
          [popoverContent]="ssoTooltip"
          [(modelValue)]="formModel.ssoEnabled"
          [isDisabled]="!isSuperAdmin"
          (onUpdate)="ssoEnabledToggleClicked($event)"
        >
        </cc-input-toggle>
      </div>
    </div>
    <ng-template #ssoTooltip>
      <div i18n id="ssoTooltip">
        This setting indicates whether SSO has been turned on for this Sitemate Start Account. Adjusting this
        toggle on its own does not turn SSO on/off.
        <br />
        <br />
        Note: SSO is not available on the Dashpivot Standard plan.
      </div>
    </ng-template>

    <!-- Save -->
    <div class="sm-mb-8 sm-text-left">
      <button
        type="submit"
        data-test="save-button"
        class="sm-p-2 button-green sm-mb-6 sm-rounded button-green"
        [class.disabled]="!canSaveSettings || isSaving"
        (click)="onSubmit($event)"
      >
        Save changes
      </button>
    </div>
  </form>
</ng-template>
